import { z } from 'zod';
import { BorderStyleSchema } from '../setting';
import { PaddingSettingSchema } from '../setting/padding-setting';
import { ShadowSettingKeySchema } from '../setting/shadow-setting';
import { TipTapContentSchema } from '../tiptap-content.schema';
import { BasePinComponentSchema, BasePinComponentSettingsSchema, BoxSchema } from './base-pin-component';

const LayoutModeSchema = z.enum(['AUTO', 'CUSTOM']);
export type LayoutMode = z.infer<typeof LayoutModeSchema>;

export const CategoryAreaPinComponentCategoryThemeSettingsSchema = z
  .object({
    backgroundColor: z.string().optional(),
    backgroundImage: z.string().optional(),
    borderColor: z.string().optional(),
    borderSize: z.number().optional(),
    borderStyle: BorderStyleSchema.optional(),
    borderRadius: z.number().optional(),
    shadow: ShadowSettingKeySchema,
    padding: PaddingSettingSchema.optional(),
    color: z.string().optional(),
  })
  .optional();

export const CategoryAreaPinComponentCategorySchema = z.object({
  id: z.string(),
  label: z.string().optional(),
  text: TipTapContentSchema.optional(),
  layout: BoxSchema,
  style: CategoryAreaPinComponentCategoryThemeSettingsSchema,
});

export type CategoryAreaPinComponentCategory = z.infer<typeof CategoryAreaPinComponentCategorySchema>;

export const CategoryAreaPinComponentPinThemeSettingsSchema = z.object({
  backgroundColor: z.string().optional(),
  backgroundImage: z.string().optional(),
  borderColor: z.string().optional(),
  borderSize: z.number().optional(),
  borderStyle: BorderStyleSchema.optional(),
  borderRadius: z.number().optional(),
  shadow: ShadowSettingKeySchema.optional(),
  padding: PaddingSettingSchema.optional(),
});
export type CategoryAreaPinComponentPinThemeSettings = z.infer<typeof CategoryAreaPinComponentPinThemeSettingsSchema>;

const CategoryAreaPinComponentSettingsSchema = BasePinComponentSettingsSchema.extend(
  CategoryAreaPinComponentPinThemeSettingsSchema.extend(
    z.object({
      layoutMode: LayoutModeSchema,
      categories: z.array(CategoryAreaPinComponentCategorySchema),
    }).shape
  ).shape
);

export type CategoryAreaPinComponentSettings = z.infer<typeof CategoryAreaPinComponentSettingsSchema>;

export const CategoryAreaPinComponentTypeSchema = z.literal('CATEGORY_AREA');

export const CategoryAreaPinComponentSchema = BasePinComponentSchema.extend(
  z.object({
    type: CategoryAreaPinComponentTypeSchema,
    settings: CategoryAreaPinComponentSettingsSchema,
  }).shape
);
